import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { TrashEmpty } from '../../../../../shared/Assets/sessionDetailsSVGs';
import { RED } from '../../../../../shared/Helpers/colors';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { ProgramProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { deleteProgram } from '../../../../../redux/State/clientSlice/clientProgramSlice';
import { useProgramsContext } from '../ProgramsContext';

const DeleteContent = ({ data, onClose }: { data: ProgramProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { fetchData } = useProgramsContext();
	const isDeleting = useSelector((state) => state.clientProgram.isDeleting);

	const deleteHandler = () => {
		dispatch(deleteProgram(data))
			.then(unwrapResult)
			.then(() => {
				fetchData();
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<ButtonWrapper isInModal>
			<CustomButton title="Yes" onClick={deleteHandler} disabled={isDeleting} />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</ButtonWrapper>
	);
};

const DeleteProgram = ({ data, onlyIcon }: { data: ProgramProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);
	const isDeleting = useSelector((state) => state.clientProgram.isDeleting);

	return (
		<>
			<div className="actionRow" onClick={() => setOpen(true)}>
				<div className="actionIcon">
					<TrashEmpty color={RED.BASE} />
				</div>
				{!onlyIcon && (
					<div className="actionContent">
						<Text title="Delete" type="psm" fontWeight="medium" />
					</div>
				)}
			</div>

			<CustomAlert
				isBusy={isDeleting}
				title="Are you sure you want to delete the selected program?"
				open={open}
				onClose={closeHandler}
				Content={({ onClose }) => <DeleteContent data={data} onClose={onClose} />}
			/>
		</>
	);
};

export default DeleteProgram;
